import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Maps a URL slug / chat type to its backend conversation namespace
const slugFor = (chatType) =>
  chatType === "ADMIN_EMPLOYEE" ? "admin-employee" : "client-admin";

/**
 * Builds the api object GenericChatTab expects, bound to a chat type.
 * Used by the standalone full-page chat so any chat type works from one place.
 */
export const createConversationApi = (chatType) => {
  const slug = slugFor(chatType);

  return {
    getMeta: (payload) =>
      apiClient.post(`/project/conversation/${slug}/get-meta`, payload),

    getMessages: (payload) =>
      apiClient.post(`/project/conversation/${slug}/get-all`, payload),

    uploadToS3: async (file, projectTitle = "Chat_File") => {
      const res = await apiClient.post("/file-uploader/generate-presigned-url", {
        directory: process.env.REACT_APP_CHATTING_DIRECTORY,
        projectTitle,
        contentType: file.type,
      });

      const { url } = res.data.data;

      await axios.put(url, file, {
        headers: { "Content-Type": file.type },
      });

      return url.split("?")[0];
    },

    deleteUploadedFile: async (fileUrl) =>
      apiClient.post("/file-uploader/delete-file", { URLs: [fileUrl] }),
  };
};

// Normalises a URL slug (e.g. "client-admin") to the internal chat type constant
export const chatTypeFromSlug = (slug) => {
  switch ((slug || "").toLowerCase()) {
    case "admin-employee":
      return "ADMIN_EMPLOYEE";
    case "client-admin":
      return "CLIENT_ADMIN";
    default:
      return null;
  }
};
